import { MagnifyingGlassIcon, XIcon } from '@phosphor-icons/react';
import { Input } from './input';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export function SearchBar({
  value,
  onChange,
  placeholder = 'Explore events',
  className = '',
}: SearchBarProps) {
  return (
    <div className={`relative ${className}`}>
      {!value && (
        <MagnifyingGlassIcon
          className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground pointer-events-none"
          size={20}
          weight="regular"
        />
      )}
      {value && (
        <button
          type="button"
          onClick={() => onChange('')}
          className="absolute right-3 top-1/2 transform -translate-y-1/2 text-muted-foreground hover:text-foreground transition-colors cursor-pointer"
          aria-label="Clear search"
        >
          <XIcon size={20} weight="regular" />
        </button>
      )}
      <Input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`h-12 rounded-lg border-purple-300 focus-visible:border-purple-300 py-3 ${value ? 'pr-10' : 'pl-10'}`}
      />
    </div>
  );
}
